import { FiniteListWithAsyncLoaderAbstract, ListProps } from "../shared/components/Components";
import { useMercuryContext } from "../context";

export const fetchLanguageCodes = async (context: any) => {
  const { data } = await context.gpClient.get(
    "/google-gp-v1/plp/uniqueLanguageCodes"
  );
  return data.map((item: string) => ({
    title: item,
    value: item,
  }));
};

export const fetchLanguageCatalogCodes = async (context: any) => {
  const { data } = await context.gpClient.get("/google-gp-v1/languageCodes");
  return data
    .filter((item: { code: string }) => item.code !== "ALL")
    .map((item: { code: string }) => ({
      title: item.code,
      value: item.code,
    }));
};
class LanguageCodeFilter extends FiniteListWithAsyncLoaderAbstract {
  fetch() {
    return fetchLanguageCodes(this.props.context);
  }
}

class LanguageCatalogCodeFilter extends FiniteListWithAsyncLoaderAbstract {
  fetch() {
    return fetchLanguageCatalogCodes(this.props.context);
  }
}

export const LanguageCatalogCodeFilterComponent = (props: ListProps) => {
  const context = useMercuryContext();
  return <LanguageCatalogCodeFilter context={context} {...props} />;
};

export default (props: ListProps) => {
  const context = useMercuryContext();
  return <LanguageCodeFilter context={context} {...props} />;
};
